import { createSlice } from '@reduxjs/toolkit';
import { Resource } from 'model/Resource';
import { ConfigsState, STORE_NAME } from 'reduxStore/configs/initialState';

import { fetchConstantsAndTimezones } from './asyncActions';

export const configsSlice = createSlice({
  name: STORE_NAME,
  initialState: ConfigsState.INITIAL_DOMAIN,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchConstantsAndTimezones.pending, (state) => {
        state.constants = Resource.createPendingResource();
        state.timezones = Resource.createPendingResource();
      })
      .addCase(fetchConstantsAndTimezones.fulfilled, (state, action) => {
        state.constants = Resource.createResolvedResource({ data: action.payload.constants });
        state.timezones = Resource.createResolvedResource({ data: action.payload.timezones });
      })
      .addCase(fetchConstantsAndTimezones.rejected, (state, action) => {
        state.constants = Resource.createRejectedResource({ error: action.error });
        state.timezones = Resource.createRejectedResource({ error: action.error });
      });
  },
});
